<template>
  <div class="container-fluid">
    <footer class="text-center text-muted pb-1 tl-footer">
      &copy; just bookmark it! 2018-2025
      <span class="border-left ml-1 mr-2"></span>
      <i class="bi bi-envelope"></i> <a href="mailto:support@justbookmark.it">support@justbookmark.it</a>
      <span class="border-left ml-2 mr-2"></span>
      <router-link to="/privacy" class="">privacy policy</router-link>
    </footer>
    <p></p>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

.tl-footer {
  font-size: 0.8em;
}
</style>
